import React from 'react';
import { Link, Routes, Route, Navigate, useNavigate } from 'react-router-dom'; 
import AddIcon from '@mui/icons-material/Add';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import GridViewIcon from '@mui/icons-material/GridView';
import ImageIcon from '@mui/icons-material/Image';
import LogoutIcon from '@mui/icons-material/Logout';
import BlogPosts from './BlogPosts';
import BlogManagement from './BlogManagement';
import BlogUpdate from './BlogUpdate';
import Dashboard from './Dashboard';
import BodyImages from './BodyImages';

const Admin = ({ onLogout }) => {
  const navigate = useNavigate();

  const handleLogout = () => {
    const confirmLogout = window.confirm('Are you sure you want to log out?');
    if (confirmLogout) {
      onLogout(); // Clear login state
      navigate('/login'); // Redirect to login page
    }
  };

  return (
    <>
      <div className="container-fluid">
        <div className="row">
          <div className="col-xxl-2 col-xl-2 col-lg-3 col-md-3 col-sm-4 pr-0 pl-0">
            <aside>
              <div className="aside_inner_section">
                <img
                  src="https://kvch.in/assets-new/img/footer-logo.webp"
                  style={{ width: 'auto', height: '40px', marginBottom: '2rem' }}
                  alt="Logo"
                />
                <Link to="dashboard"><GridViewIcon /> Dashboard</Link>
                <Link to="blogmanage"><FormatListBulletedIcon /> List of Blogs</Link>
                <Link to="posts"><AddIcon /> Add Blogs</Link>
                <Link to="bodyimage" target="_blank"><ImageIcon /> Body Images</Link>
                <Link onClick={handleLogout}><LogoutIcon /> Log Out</Link>
              </div>
            </aside>
          </div>
          <div className="col-xxl-10 col-xl-10 col-lg-9 col-md-9 col-sm-8 pr-0 pl-0">
            <Routes>
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="blogmanage" element={<BlogManagement />} />
              <Route path="posts" element={<BlogPosts />} />
              <Route path=":slug" element={<BlogUpdate />} />
              <Route path="bodyimage" element={<BodyImages />} />
              <Route path="*" element={<Navigate to="dashboard" replace />} />
            </Routes>
          </div>
        </div>
      </div>
    </>
  );
};

export default Admin;
